<template>
  <div class="layoutWrapper barren">
    <Nuxt />
  </div>
</template>

<script>
import thirdparties from "~/mixins/third_party/load"

export default {
  mixins: [...thirdparties],
  mounted() {
    this.$store.dispatch("csrf/FETCH")
  },
}
</script>
